module.exports = __webpack_public_path__ + "static/media/rose.d10c5b04.png";